import ObservablePropertyDescriptorObject from '../../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../../utils/PropertyDescriptor';
import ModelActionProperty from "./ModelActionProperty";
import ModelActionPropertyBase from "./ModelActionPropertyBase";

export default class Model extends ModelActionPropertyBase {

    script = new PropertyDescriptor(``, '使用 Javascript 编写断言逻辑', "高级", "js", "#anticon-Documentation", {
        description: '在动作触发时，执行此处的断言逻辑，结果为 true 时，执行为真时动作；结果为 false 时，执行为假时动作；结果为 null 或 undefined 时，执行为空时动作',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    actionsTrue = new PropertyDescriptor([], '为真时', "动作", "objects", "#anticon-success", {
        description: "结果为真时，执行的动作。当有多个动作时，将从上到下依次执行",
        modelTemplate: ModelActionProperty,
        modelGetter: (opts) => {
            const m = new ModelActionProperty(opts);
            // m._sys.__runScript = this._sys.ui && this._sys.ui.runScript.bind(this._sys.ui);
            return m;
        },
    });

    actionsFalse = new PropertyDescriptor([], '为假时', "动作", "objects", "#anticon-Exceptionlabel_white", {
        description: "结果为假时，执行的动作。当有多个动作时，将从上到下依次执行",
        modelTemplate: ModelActionProperty,
        modelGetter: (opts) => {
            const m = new ModelActionProperty(opts);
            // m._sys.__runScript = this._sys.ui && this._sys.ui.runScript.bind(this._sys.ui);
            return m;
        },
    });

    actionsNull = new PropertyDescriptor([], '为空时', "动作", "objects", "#anticon-GroupCopy", {
        description: "结果为空时，执行的动作。当有多个动作时，将从上到下依次执行",
        modelTemplate: ModelActionProperty,
        modelGetter: (opts) => {
            const m = new ModelActionProperty(opts);
            // m._sys.__runScript = this._sys.ui && this._sys.ui.runScript.bind(this._sys.ui);
            return m;
        },
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }

    run(data, opts) {
        const value = opts.runScript(this.script, data, undefined, undefined, { throwException: true });

        if (value === null || value === undefined) {
            this.actionsNull.forEach(c => {
                c.run(data, opts);
            });
        }
        else if (value) {
            this.actionsTrue.forEach(c => {
                c.run(data, opts);
            });
        }
        else {
            this.actionsFalse.forEach(c => {
                c.run(data, opts);
            });
        }

        return value;
    }

    toString() {
        return this.script;
    }
}
